import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { CaretUpFill } from "react-bootstrap-icons";

export default function BackToTopButton({ smooth = true, scrollFromTop = 500, container = null }) {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const element = container?.current ?? window;
        function handleScroll() {
            const scrollTop = element.scrollTop ?? element.scrollY;
            if (scrollTop > scrollFromTop) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        }

        element.addEventListener("scroll", handleScroll);

        return () => {
            element.removeEventListener("scroll", handleScroll);
        };
    }, [container, scrollFromTop]);

    function scrollToTop() {
        const element = container?.current ?? window;

        if (smooth) {
            element.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        } else {
            element.scrollTo(0, 0);
        }
    }

    return (
        <Button size="sm" className={`${showButton ? "d-block" : "d-none"} btn-back-to-top`} onClick={scrollToTop}>
            <CaretUpFill width={30} height={30} />
        </Button>
    );
}
